module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic12.8dcb9a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic12.png
// module id = 530
// module chunks = 1